export default __webpack_public_path__ + "static/media/ennasim.f0cd6b52.png";